export default __webpack_public_path__ + "static/media/consulting.702535fa.jpeg";